<template>
<div>
    <h2>Invalid page</h2>
    <p>{{$route.path}}</p>
</div>
</template>